export default class WalletTemplatesListController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.store = this.injector.get('WalletTemplates');
        this.state = this.injector.get('$state');

        this._initStore();
    }

    _initStore() {
        this.store.dispatch('loadWorkflows', 'passbooks::list');
        this.store.commit('setEmptyListActions', [
            'create-passbook'
        ]);
        this.store.commit('setVm', this);
    }

    goToDetails(payload) {
        this.state.go(
            'app.wallets.templates.details',
            {
                id: payload.row.id,
                store: this.store
            },
            {
                location: true
            }
        );
    }
}

WalletTemplatesListController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/controllers/pages/list.js